import React from 'react';
import './index.less';

const AuthModal = ({open}) => {
  return (
    <div className={open === true ? 'auth-modal auth-modal-active' : 'auth-modal'}></div>
  );
};

export default AuthModal;